module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17KyVbf/cover.jpeg?1685327423761",
      "alt": "This image is the cover for the book Late in the Day, The Vault"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Late in the Day, The Vault\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Second from The Vault")])])]), _c('p', [_vm._v("Terrence Moss. Conrad Harris. Gold Team Leader. Darius Hawthorne. The Vault. Juggling all these names would bother some, but for Darius, it’s business as usual. When he closes a chapter in his life, he leaves a name—and the people associated with it—behind. He’s managed to keep a few colleagues, even fewer friends, and no companionship through his forty-plus years… but that’s now changing.")]), _vm._v(" "), _c('p', [_vm._v("The newest chapter of his life is bringing serious change: a stable home, a recovered identity, an unlikely family, and now a chance encounter with the one man Darius ever loved: Efrem Lahm. The reasons they parted are still valid, and there’s no way they can trust each other. But Efrem has already decided he won’t let Darius go… and Darius will have to decide if he wants to take a chance with his heart this late in the day. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Calmes\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0